import React from "react";
import { Link } from "react-router-dom";
import "./style.scss";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-warpper">
          <div className="line mid">
            <Link to="/"><p>{t("footer.privacy")}</p></Link>
            <Link to="/"><p>{t("footer.terms")}</p></Link>
            <Link to="/"><p>{t("footer.videoPolicy")}</p></Link>
            <Link to="/"><p>{t("footer.siteMap")}</p></Link>
            <Link to="/"><p>{t("footer.contact")}</p></Link>
            <Link to="/"><p>{t("footer.ministry")}</p></Link>
          </div>
          <div className="line bottom">
            <footer className="footer">
              {/* Seoul */}
              <div className="footer-section">
                <h3 className="footer-title">ILWALL Seoul</h3>
                <div className="footer-content">
                  <div className="footer-col">
                    <p>{t("footer.seoul.businessNo")}</p>
                    <p>{t("footer.seoul.address")}</p>
                    <p>{t("footer.seoul.copyright")}</p>
                  </div>
                  <div className="footer-col">
                    <p><strong>{t("footer.headOffice")}: </strong>Cha Jeong Min</p>
                    <p><strong>{t("footer.mobile")}:</strong> +82 70-4272-8645</p>
                    <p>ilwall.hello@gmail.com</p>
                  </div>
                </div>
              </div>
              {/* Osaka */}
              <div className="footer-section">
                <h3 className="footer-title">ILWALL Tokyo</h3>
                <div className="footer-content">
                  <div className="footer-col">
                    <p>{t("footer.tokyo.address1")}</p>
                    <p>{t("footer.tokyo.address2")}</p>
                  </div>
                  <div className="footer-col">
                    <p><strong>Tokyo Branch:</strong> Cass</p>
                    <p><strong>{t("footer.mobile")}:</strong> +80-10-8485-4952</p>
                    <p>ilwall.hello@gmail.com</p>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;